import type { Configuration, PopupRequest } from "@azure/msal-browser";

const CIAM_CLIENT_ID = import.meta.env.VITE_CIAM_CLIENT_ID;
const CIAM_AUTHORITY = import.meta.env.VITE_CIAM_AUTHORITY;
const CIAM_KNOWN_AUTHORITY = import.meta.env.VITE_CIAM_KNOWN_AUTHORITY;

export const msalConfig: Configuration = {
    auth: {
        clientId: CIAM_CLIENT_ID,
        authority: CIAM_AUTHORITY,
        knownAuthorities: [CIAM_KNOWN_AUTHORITY],
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest: PopupRequest = {
    scopes: ["openid", `${CIAM_CLIENT_ID}/login`],
};
